<template>
<div class="bar">
    <div @dblclick="acivateErrorsDetailsModal(object)" :class="classify(key)" :style="getStyle(object.totalFailures)" v-for="(object, key) in area" :key="key">
      <span v-if="key !== 'totalFailures'">
        {{object.totalFailures}}
      </span>
    </div>
</div>
</template>

<script>

export default {
  props: ['area', 'maxFailuresInArea', 'checkedRestaurants', 'dateFrom', 'dateTo'],
  created () {
  },
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
    getStyle (object) {
      if (!object) return ''
      return 'float:left; border:0px solid white; height:30px; width:' + (object / this.maxFailuresInArea * 100) + '%'
    },
    classify (string) {
      return string.replace(/[\W_]+/g, '-').toLowerCase()
    },
    acivateErrorsDetailsModal (data) {
      this.$emit('acivateErrorsDetailsModal', {
        networkerrormatrix_ids: [...new Set(data.map(row => row.networkerrormatrix_id))],
        checkedRestaurants: this.checkedRestaurants,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo
      })
    }
  },
  computed: {
  }
}
</script>
<style lang="sass" scoped>
@import "~sass/_variables.scss"
.kioskapi-application
  background-color: #ff0000
.kioskfrontend
  background-color: #aa0000
.printer
  background-color: #0000b0
.terminal
  background-color: #3333b0
.ethernet
  background-color: #00b000
.kiosk-controller
  background-color: #33b033
.database
  background-color: #ffb000
</style>



// WEBPACK FOOTER //
// src/components/reports/ErrorBar.vue